import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
    name: 'markdown'
})
export class MarkdownPipe implements PipeTransform {

    constructor(private sanitizer: DomSanitizer) { }

    transform(value: string): SafeHtml {
        if (!value) {
            return '';
        }

        let html = this.escapeHtml(value);

        // Convert markdown to HTML
        html = this.convertMarkdown(html);

        return this.sanitizer.bypassSecurityTrustHtml(html);
    }

    private escapeHtml(text: string): string {
        const div = document.createElement('div');
        div.textContent = text;
        return div.innerHTML;
    }

    private convertMarkdown(text: string): string {
        let html = text;

        // Bold: **text** or __text__
        html = html.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
        html = html.replace(/__(.+?)__/g, '<strong>$1</strong>');

        // Italic: *text* or _text_ (but not inside words)
        html = html.replace(/(?<!\*)\*(?!\*)(.+?)(?<!\*)\*(?!\*)/g, '<em>$1</em>');

        // Inline code: `code`
        html = html.replace(/`([^`]+)`/g, '<code>$1</code>');

        // Headers: # ## ###
        html = html.replace(/^### (.+)$/gm, '<h6 class="mb-2 mt-3">$1</h6>');
        html = html.replace(/^## (.+)$/gm, '<h5 class="mb-2 mt-3">$1</h5>');
        html = html.replace(/^# (.+)$/gm, '<h4 class="mb-2 mt-3">$1</h4>');

        // Unordered lists: - item (handle multi-line)
        html = html.replace(/^(\s*)- (.+)$/gm, '$1<li>$2</li>');

        // Ordered lists: 1. item
        html = html.replace(/^\d+\. (.+)$/gm, '<li>$1</li>');

        // Wrap consecutive <li> items in <ul> or <ol>
        html = this.wrapListItems(html);

        // Line breaks: convert \n to <br> (except inside lists)
        html = html.replace(/\n(?!<\/?(ul|ol|li))/g, '<br>');

        // Clean up multiple <br> tags
        html = html.replace(/(<br>){3,}/g, '<br><br>');

        return html;
    }

    private wrapListItems(html: string): string {
        const lines = html.split('\n');
        const result: string[] = [];
        let inList = false;
        let listType = '';

        for (let i = 0; i < lines.length; i++) {
            const line = lines[i];
            const isListItem = line.trim().startsWith('<li>');

            if (isListItem && !inList) {
                // Start a new list
                inList = true;
                listType = 'ul';
                result.push(`<${listType} class="mb-2 ps-3">`);
                result.push(line);
            } else if (isListItem && inList) {
                // Continue list
                result.push(line);
            } else if (!isListItem && inList) {
                // End list
                result.push(`</${listType}>`);
                inList = false;
                result.push(line);
            } else {
                result.push(line);
            }
        }

        // Close list if still open at end
        if (inList) {
            result.push(`</${listType}>`);
        }

        return result.join('\n');
    }
}
